/* eslint-disable jsx-a11y/aria-role */
import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'
import LoginContainer from 'components/Forms/Login/LoginFormContainer'
import Profile from 'pages/Profile'
import AccountManagement from 'pages/admin/AccountsManagement'
import Stats from 'pages/admin/Stats'
import AuthProvider from 'context/AuthContext'
import AccountDashboard from 'pages/account/Dashboard'
import MediatorDashboard from 'pages/mediator/Dashboard'
import CallAttempts from 'pages/mediator/CallAttempts'
import RegisterUsers from 'pages/admin/RegisterUsers'
import Translators from 'pages/mediator/Translators'
import TranslatorDashboard from 'pages/translator/Dashboard'
import AccountsTable from 'pages/client/Accounts'
import AddAccount from 'pages/client/AddAccount'
import { Roles } from 'utils/enums'
import Clients from 'components/mediators/Tables/Clients'
import Identify from 'pages/translator/Identify'
import NavBar from 'components/layout/NavBar'
import DeletedUsers from 'pages/admin/DeletedUsers'
import AdminDataProvider from 'context/AdminDataContext'
import JoinRequest from 'pages/joinRequest'
import CallFinishedGuest from 'pages/callFinished/Guest'
import ErrorBoundary from 'helpers/ErrorBoundary'
import ClientDataProvider from 'context/ClientDataContext'
import TranslatorDataProvider from 'context/TranslatorContext'
import MediatorProvider from 'context/MediatorContext'
import CallFinishedTranslator from 'pages/callFinished/translator'
import CallFinishedAccount from 'pages/callFinished/account'
import AccountDataProvider from 'context/AccountContext'
import QRLogin from 'pages/QrLogin'
import Layout from 'components/layout'
import Redirector from './Redirector'
import IdentifiedTranslatorProvider from '../context/IdentifiedTranslatorContext'

export const roles = {
  [Roles.Admin.role]: {
    paths: [
      {
        path: Roles.Admin.mainPath,
        element: <AdminDataProvider />,
        paths: [
          { path: '', name: 'Inicio', element: <Profile /> },
          {
            path: 'management/:role?',
            name: 'Administración de Cuentas',
            element: <AccountManagement />,
          },
          { path: 'stats', name: 'Estadísticas', element: <Stats /> },
          {
            path: 'register',
            name: 'Creación de usuarios',
            element: <RegisterUsers />,
          },
          {
            path: 'deleted/:role?',
            name: 'Usuarios eliminados',
            element: <DeletedUsers />,
          },
          {
            path: 'call-attempts',
            name: 'Registro de llamadas',
            element: <CallAttempts />,
          },
        ],
      },
    ],
  },
  [Roles.Mediator.role]: {
    paths: [
      {
        path: Roles.Mediator.mainPath,
        element: <MediatorProvider />,
        paths: [
          { name: 'Inicio', path: '', element: <MediatorDashboard /> },
          {
            name: 'Ver intérpretes',
            path: 'translators/:id?',
            element: <Translators />,
          },
          { name: 'Ver empresas', path: 'clients', element: <Clients /> },
        ],
      },
    ],
  },
  [Roles.Client.role]: {
    paths: [
      {
        path: Roles.Client.mainPath,
        element: <ClientDataProvider />,
        paths: [
          { name: 'Inicio', path: '', element: <Profile /> },
          {
            name: 'Mis cuentas',
            path: 'accounts',
            element: <AccountsTable />,
          },
          {
            name: 'Crear cuenta',
            path: 'create-account',
            element: <AddAccount />,
          },
        ],
      },
    ],
  },
  [Roles.Translator.role]: {
    paths: [
      {
        element: <IdentifiedTranslatorProvider />,
        path: Roles.Translator.mainPath,
        paths: [
          { path: 'identify', element: <Identify /> },
          {
            element: <TranslatorDataProvider />,
            paths: [
              {
                path: 'callFinished/:callId?',
                element: <CallFinishedTranslator />,
              },
              {
                path: '',
                element: <TranslatorDashboard />,
              },
            ],
          },
        ],
      },
    ],
  },
  [Roles.Account.role]: {
    paths: [
      {
        path: Roles.Account.mainPath,
        element: <AccountDataProvider />,
        paths: [
          { path: '', element: <AccountDashboard /> },
          { path: 'callFinished', element: <CallFinishedAccount /> },
        ],
      },
    ],
  },
}

function Router() {
  return (
    <Routes>
      <Route path='/login' element={<LoginContainer />} />
      <Route path='/qr-login' element={<QRLogin />} />
      <Route path='/callFinishedGuest' element={<CallFinishedGuest />} />
      <Route path='/joinRequest' element={<JoinRequest />} />
      <Route
        element={(
          <AuthProvider>
            <NavBar />
          </AuthProvider>
        )}
      >
        <Route
          element={(
            <ErrorBoundary>
              <Layout />
            </ErrorBoundary>
          )}
        >
          {traversePaths(roles[Roles.Admin.role].paths)}
          {traversePaths(roles[Roles.Mediator.role].paths)}
          {traversePaths(roles[Roles.Client.role].paths)}
        </Route>
        {traversePaths(roles[Roles.Translator.role].paths)}
        {traversePaths(roles[Roles.Account.role].paths)}
      </Route>
      <Route path='*' element={<Redirector />} />
    </Routes>
  )
}

const traversePaths = (paths) => {
  return paths.map((p) => {
    const element = p.element || <Outlet />
    if (!p.paths) {
      return <Route key={element.type.name} path={p.path} element={element} />
    }
    return (
      <Route key={element.type.name} path={p.path} element={element}>
        {traversePaths(p.paths)}
      </Route>
    )
  })
}

export default Router
